// Helper para respetar rangos abiertos/cerrados como en WinForms
export function getGaugeColor(value, ranges, fallback = "grey") {
  if (value === null || value === undefined || Number.isNaN(value)) return fallback;

  for (const r of ranges) {
    const minOk =
      r.min === undefined
        ? true
        : (r.includeMin ?? true)
          ? value >= r.min
          : value > r.min;

    const maxOk =
      r.max === undefined
        ? true
        : (r.includeMax ?? true)
          ? value <= r.max
          : value < r.max;

    if (minOk && maxOk) return r.color;
  }
  return fallback;
}

export const optichiller2CompCT6GaugeConfig = [ 
  // 1) Presión Succión C1
  {
    key: "presSuccionComp1",
    title: "Pres. Succión Compresor 1",
    unit: "psi",
    ranges: [
      { min: 33, max: 40, color: "green" }, // 33 <= x <= 40
      { min: 28, max: 33, color: "yellow", includeMin: false, includeMax: false }, // 28 < x < 33
      { min: 40, max: 68, color: "yellow", includeMin: false, includeMax: false }, // 40 < x < 68
      { min: 0,  max: 28, color: "red" },   // 0 <= x <= 28
      { min: 68, max: 1000, color: "red" }, // 68 <= x <= 1000
    ],
  },

  // 2) Presión Succión C2
  {
    key: "presSuccionComp2",
    title: "Pres. Succión Compresor 2",
    unit: "psi",
    ranges: [
      { min: 33, max: 40, color: "green" },
      { min: 28, max: 33, color: "yellow", includeMin: false, includeMax: false },
      { min: 40, max: 68, color: "yellow", includeMin: false, includeMax: false },
      { min: 0,  max: 28, color: "red" },
      { min: 68, max: 1000, color: "red" },
    ],
  },

  // 3) Presión Descarga C1
  {
    key: "presionDescargaComp1",
    title: "Pres. Descarga Compresor 1",
    unit: "psi",
    ranges: [
      { min: 100, max: 139.99, color: "green" }, // 100 <= x <= 120
      { min: 89,  max: 99.99, color: "yellow", includeMin: false, includeMax: false }, // 89 < x < 100
      { min: 140, max: 149.99, color: "yellow", includeMin: false, includeMax: false }, // 120 < x < 131
      { min: 0,   max: 88.99,  color: "red" },   // 0 <= x <= 89
      { min: 150, max: 100000, color: "red" },// 131 <= x <= 100000
    ],
  },

  // 4) Presión Descarga C2
  {
    key: "presionDescargaComp2",
    title: "Pres. Descarga Compresor 2",
    unit: "psi",
    ranges: [
      { min: 100, max: 139.99, color: "green" }, // 100 <= x <= 120 
      { min: 89,  max: 99.99, color: "yellow", includeMin: false, includeMax: false }, // 89 < x < 100
      { min: 140, max: 149.99, color: "yellow", includeMin: false, includeMax: false }, // 120 < x < 131
      { min: 0,   max: 88.99,  color: "red" },   // 0 <= x <= 89
      { min: 150, max: 100000, color: "red" },// 131 <= x <= 100000
    ],
  },

  // 5) Temperatura Proceso Entrada
  {
    key: "tempProcesoEntrada",
    title: "Temp. Proceso Entrada",
    unit: "°C",
    ranges: [
      { min: 7,  max: 14.99, color: "green" },
      { min: 5,  max: 6.99,  color: "yellow", includeMin: false, includeMax: false },
      { min: 15, max: 24.99, color: "yellow", includeMin: false, includeMax: false },
      { min: 0,  max: 4.99,  color: "red" },
      { min: 25, max: 50000, color: "red" },
    ],
  },

  // 6) Temperatura Proceso Salida
  {
    key: "tempProcesoSalida",
    title: "Temp. Proceso Salida",
    unit: "°C",
    ranges: [
      { min: 7,  max: 11.99, color: "green" },
      { min: 5,  max: 6.99,  color: "yellow", includeMin: false, includeMax: false },
      { min: 12, max: 19.99, color: "yellow", includeMin: false, includeMax: false },
      { min: 0,  max: 4.99,  color: "red" },
      { min: 20, max: 50000, color: "red" },
    ],
  },

  // 7) Temperatura Torre Entrada
  {
    key: "tempTorreEntrada",
    title: "Temp. Torre Entrada",
    unit: "°C",
    ranges: [
      { min: 27, max: 30.99, color: "green" }, // 28 <= x <= 31
      { min: 25, max: 26.99, color: "yellow", includeMin: false, includeMax: false }, // 25 < x < 28
      { min: 31, max: 34.99, color: "yellow", includeMin: false, includeMax: false }, // 31 < x < 35
      { min: 0,  max: 24.99, color: "red" },   // 0 <= x <= 25
      { min: 35, max: 50000, color: "red" },   // 35 <= x <= 50
    ],
  },

  // 8) Temperatura Torre Salida
  {
    key: "tempTorreSalida",
    title: "Temp. Torre Salida",
    unit: "°C",
    ranges: [
      { min: 30, max: 34.99, color: "green" }, // 32 <= x <= 35
      { min: 26, max: 29.99, color: "yellow", includeMin: false, includeMax: false }, // 26 < x < 32
      { min: 35, max: 37.99, color: "yellow", includeMin: false, includeMax: false }, // 35 < x < 38
      { min: 0,  max: 25.99, color: "red" },   // 0 <= x <= 26
      { min: 38, max: 500000, color: "red" },   // 38 <= x <= 50
    ],
  },

  // 9) Temperatura Descarga C1
  {
    key: "tempDescargaComp1",
    title: "Temp. Descarga Compresor 1",
    unit: "°C",
    ranges: [
      { min: 45, max: 70, color: "green" }, // 45 <= x <= 70
      { min: 43, max: 45, color: "yellow", includeMin: false, includeMax: false }, // 43 < x < 45
      { min: 70, max: 91, color: "yellow", includeMin: false, includeMax: false }, // 70 < x < 91
      { min: 0,  max: 43, color: "red" },   // 0 <= x <= 43
      { min: 91, max: 150, color: "red" },  // 91 <= x <= 150
    ],
  },

  // 10) Temperatura Descarga C2
  {
    key: "tempDescargaComp2",
    title: "Temp. Descarga Compresor 2",
    unit: "°C",
    ranges: [
      { min: 45, max: 70, color: "green" },
      { min: 43, max: 45, color: "yellow", includeMin: false, includeMax: false },
      { min: 70, max: 91, color: "yellow", includeMin: false, includeMax: false },
      { min: 0,  max: 43, color: "red" },
      { min: 91, max: 150, color: "red" },
    ],
  },
];
